module.exports = __webpack_public_path__ + "img/menu-arrow-up.55978c39.png";